export const IMAGES = [
  { src: "https://i.ibb.co/tBcXzm7/image.jpg", thumbnail: "https://i.ibb.co/tBcXzm7/image.jpg" },
  { src: "https://i.ibb.co/8sbtS9D/1.jpg", thumbnail: "https://i.ibb.co/8sbtS9D/1.jpg" },
  { src: "https://i.ibb.co/f9F8mq9/2.jpg", thumbnail: "https://i.ibb.co/f9F8mq9/2.jpg" },
  { src: "https://i.ibb.co/376jqgz/3.jpg", thumbnail: "https://i.ibb.co/376jqgz/3.jpg" },
];
